import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import "react-loading-skeleton/dist/skeleton.css";

/**
 * Start the MSW browser worker only when explicitly opted in (DEF-008).
 *
 * Gated behind REACT_APP_ENABLE_MOCKS so it defaults OFF: `npm start` hits the
 * real backend via the dev proxy, and admin writes (/api/admin/*) actually
 * persist. Set REACT_APP_ENABLE_MOCKS=true for backend-less UI work.
 *
 * Note: this only affects the browser worker. Jest tests use the Node MSW
 * server (src/mocks/server.js via setupServer) and are unaffected by this gate.
 */
async function enableMocking() {
  if (process.env.REACT_APP_ENABLE_MOCKS !== 'true') return;
  const { worker } = await import('./mocks/browser');
  return worker.start({ onUnhandledRequest: 'bypass' });
}

enableMocking().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
});
